import { Component } from 'ca-ui';

export class VRRoomLayoutView extends Component {
  static defaultOptions = {
    componentName: 'VRRoomLayoutView',
    showPerson: true,
    assets: []
  };

  constructor (options) {
    super($.extend({}, VRRoomLayoutView.defaultOptions, options));

    this.assets = [];

    // Person
    if (this.options.showPerson) {
      this.person = $('<div class="ca-ui-vrroomlayoutview_person"></div>');
      this.el.append(this.person);
    }

    this.options.assets.forEach(
      function (asset) {
        this.addAsset(asset);
      }.bind(this)
    );
  }

  addAsset (options) {
    const mapAsset = new RoomLayoutViewAsset({
      yaw: options.yaw,
      distance: options.distance,
      minDistance: options.minDistance,
      maxDistance: options.maxDistance,
      asset: options
    });
    this.assets[options.id] = mapAsset;
    this.el.append(mapAsset.el);
  }

  removeAsset (options) {
    if (this.assets[options.id] == null) return;
    this.assets[options.id].el.remove();
  }

  moveAsset (options) {
    if (this.assets[options.id] == null) return;

    this.assets[options.id].setYaw(options.yaw);
    this.assets[options.id].setDistance(
      options.distance,
      options.minDistance,
      options.maxDistance
    );
  }

  setActiveAsset (options) {
    if (this.activeAsset) this.activeAsset.setActive(false);

    if (options == null || this.assets[options.id] == null) return;

    if (this.assets[options.id]) {
      this.activeAsset = this.assets[options.id];
      this.activeAsset.setActive(true);
    }
  }
}

export class RoomLayoutViewAsset extends Component {
  static defaultOptions = {
    componentName: 'RoomLayoutViewAsset',
    yaw: 0
  };

  constructor (options) {
    super($.extend({}, RoomLayoutViewAsset.defaultOptions, options));

    this.el.addClass('ca-ui-vrroomlayoutview_asset');

    this.assetEl = $(
      '<div class="ca-ui-vrroomlayoutview_assetobject ca-ui-vrroomlayoutview_assetobject_' +
        this.options.asset.type +
        '"></div>'
    );
    this.el.append(this.assetEl);

    this.setYaw(this.options.yaw);
    this.setDistance(
      this.options.distance,
      this.options.minDistance,
      this.options.maxDistance
    );
  }

  setActive (show) {
    this.el.toggleClass('active', show);
  }

  setDistance (distance, min, max) {
    this.assetEl.css('top', this.scale(distance, max, min, 0, 35) + '%');
  }

  setYaw (yaw) {
    this.el.css('transform', 'rotate(' + yaw + 'deg)');
  }

  scale (number, inMin, inMax, outMin, outMax) {
    return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }
}
